export enum OrderStatus {
  CANCELLED = "CANCELLED",
  CAPTURING = "CAPTURING",
  OPEN = "OPEN",
  PAID = "PAID",
  PARTIALLY_REFUNDED = "PARTIALLY_REFUNDED",
  PAYING = "PAYING",
  PROCESSED = "PROCESSED",
  REFUNDED = "REFUNDED",
  REFUNDING = "REFUNDING",
}
